import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./CreateAccount.css";
import DateBirthday from "../../Components/date-birthday/DateBirthday";

const CreateAccount = () => {
    useEffect(() => {
        document.title = "Perichert | Criar nova conta"
    }, [])

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");

    let navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        // Lógica de criação de conta aqui
        // Se a criação for bem-sucedida, navegue para outra página, por exemplo, a página de login:
        // navigate("/login");
    };

    const routeChange = (path) => {
        navigate(path);
    }

    return (
        <div>
            <div id="page-create-account">
                <div id="create-account-panel">
                    <div id="login">
                        <div className="description-account">
                            <h1 className="register-span">Cadastre-se</h1>
                            <div className="description-register">É rápido e fácil.</div>
                        </div>
                        <form className="form" id="form-data-create-account" onSubmit={handleSubmit}>
                            <div className="field" style={{marginBottom: '10px'}}>
                                <input placeholder="Email" type="email" name="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="field">
                                <input placeholder="Senha" type="password" name="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            <div className="field">
                                <input placeholder="Confirmar senha" type="passwordConfirm" name="passwordConfirm" id="passwordConfirm" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} />
                            </div>
                            <div id="birthday_wrapper">
                                <div className="mtm mbs _2_68">Data de nascimento</div>
                                <DateBirthday />
                            </div>
                            <div className="actions-create-account">
                                <button className="button-create-accoount-cancel" onClick={() => routeChange('/login')} type="button">Cancelar</button>
                                <button className="button-create" type="submit">Criar nova conta</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateAccount;
